import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const DOCUMENT_LIST_EVENTS = eventGroup({
  events: {
    documentListReloadRequested: type<{ workspaceId: string }>(),
  },
  source: 'Document List Events',
});
